import { ThemeType } from "shared/styles/theme"
import styled, { css } from "styled-components"
import theme from "styled-theming"
import colors from "../styles/colors"
import { buttonColor } from "./button/Button"

const dropdownContentBackgroundColor = theme("mode", {
    [ThemeType.light]: colors.white,
    [ThemeType.dark]: colors.dark2
});

const dropdownContentBorderColor = theme("mode", {
    [ThemeType.light]: colors.grey_2,
    [ThemeType.dark]: colors.grey_1
});

const dropdownContentItemColor = theme("mode", {
    [ThemeType.light]: colors.black,
    [ThemeType.dark]: colors.grey_5
});

const dropdownContentItemBackgroundColor = theme("mode", {
    [ThemeType.light]: colors.white,
    [ThemeType.dark]: colors.dark2
});

const dropdownContentItemBackgroundColorHover = theme("mode", {
    [ThemeType.light]: colors.grey_6,
    [ThemeType.dark]: colors.dark
});

const dropdownDisabledColor = theme("mode", {
    [ThemeType.light]: colors.grey_2,
    [ThemeType.dark]: colors.grey_2
})

export const DropdownButton = styled.div`
    display: flex;
    position: relative;
    li button, li.dropbtn {
        display: inline-block;
        color: ${buttonColor};
        font-family: "Gilroy-Medium", "medium-fallback";
        font-size: 1rem;
        text-align: center;
        text-decoration: none;
    }

    li.dropdown {
        display: inline-block;
    }

    .show {
        display: flex;
    }
`

export const DropdownContainer = styled.div`
    float: left;
    overflow: hidden;
    .dropbtn {
        cursor: pointer;
        border: none;
        outline: none;
        color: ${buttonColor};
        margin: 0;
    }
`

export const DropdownContent = styled.div<IDropdownContentProps>`
    display: none;
    overflow: hidden;
    position: absolute;
    background-color: ${dropdownContentBackgroundColor};
    min-width: 160px;
    width: max-content;
    box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.1);
    z-index: 1;
    border: 1px solid ${dropdownContentBorderColor};
    border-radius: 6px;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-evenly;
    align-items: stretch;
    z-index: 10000;

    ${props => props.pullRight && css`
        left: auto;
        right: 0;
    `}

    hr {
        margin: -1px 0;
    }

    a, button {
        font-family: "Gilroy-Regular", "regular-fallback";
        font-size: var(--small-text-font-size);
        float: none;
        color: ${dropdownContentItemColor};
        padding: 8px 48px 8px 16px;
        text-decoration: none;
        display: block;
        text-align: left;
        cursor: pointer;
        border: none;
        background-color: ${dropdownContentItemBackgroundColor};
        &:disabled {
            cursor: default;
            color: ${dropdownDisabledColor};
            background-color: ${dropdownContentItemBackgroundColor};    
        }
        &:hover:not(:disabled) {
            background-color: ${dropdownContentItemBackgroundColorHover};
        }
    }
`

interface IDropdownContentProps {
    /** Should only be used for dropdowns near window border, not applicable everywhere */
    pullRight?: boolean;
}